const accountAction = {
  RESTORE_SESSION: '@accountReducer/RESTORE_SESSION',
  CLEAR_SESSION: '@accountReducer/CLEAR_SESSION'
};

export default accountAction;
